import { useEffect } from "react";
import { useSetAtom } from "jotai";
import { useAuth } from "@/hooks/useAuth";
import { endSessionAtom } from "@/store/sessionAtoms";

// The one place a session's account data is cleared. Keyed on MSAL's own
// signed-in state, so it covers every way a session ends: our logoutPopup
// calls and the ones MSAL reports without us (another tab signs out, the
// account is removed from the cache). An expired token is not one of them:
// MSAL keeps the account and re-acquires, so isAuthenticated stays true.
// MsalProvider also starts every page load with no accounts, so this fires
// once on the first commit; nothing has been read yet, so that is a no-op,
// and it is why persisted preferences (localStorage) are not cleared here.
// Mounted once, in App.
export const useEndSessionOnSignOut = () => {
    const { isAuthenticated } = useAuth();
    const endSession = useSetAtom(endSessionAtom);

    useEffect(() => {
        if (!isAuthenticated) endSession();
    }, [isAuthenticated, endSession]);
};
